import * as ErrorMessages from './error-messages.js'

export const required = text => {
    if (text) {
        return null
    } else {
        return ErrorMessages.isRequired
    }
}

export const mustMatch = (field, fieldName) => {
    return (text, state) => {
        return state[field] === text ? null : ErrorMessages.mustMatch(fieldName)
    }
}

export const minLength = length => {
    return text => {
        return text.length >= length ? null : ErrorMessages.minLength(length)
    }
}

export const emailCheck = (strEmail, fieldName) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(strEmail).toLowerCase())
        ? null
        : ErrorMessages.isEmail(fieldName)
}



// WEBPACK FOOTER //
// ./src/component/validation/rules.js